import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import { SaveMetaMilestone_Input } from 'generated/graphql';

export type SaveMetaMilestoneFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveMetaMilestoneFormProps) => {
  const [
    fnSaveMetaMilestoneForm,
    { loading }
  ] = ds.useSaveMetaMilestone();
  const form = ds.useFormState(props.id);

  const handleSubmit = async (id: string, included: boolean, notesForClient: string) => {
    const input: SaveMetaMilestone_Input = {
      id,
      included,
      notesForClient
    };
    await fnSaveMetaMilestoneForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState.id, form.formState.included, form.formState.notesForClient);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <StyledTextField.FC
        {...form.genFieldProps('notesForClient')}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
